@for (row of rows(); track $index; let i = $index) {
  <!-- focusout, not blur: blur does not bubble out of the inner inputs -->
  <div class="flex items-center gap-2" (focusout)="handleBlur()">
    <!-- ngModel rather than the parent's form: the editor is itself the form
         control and owns the row array; each box only edits one cell of it -->
    <vx-input
      [size]="size()"
      [placeholder]="keyPlaceholder()"
      [disabled]="isDisabled()"
      [ariaLabel]="keyPlaceholder()"
      [ngModel]="row.key"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="updateKey(i, $event)" />
    <vx-input
      [size]="size()"
      [placeholder]="valuePlaceholder()"
      [disabled]="isDisabled()"
      [ariaLabel]="valuePlaceholder()"
      [ngModel]="row.value"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="updateValue(i, $event)" />
    <vx-icon-button
      icon="trash"
      variant="ghost"
      tone="secondary"
      [size]="size()"
      [disabled]="isDisabled()"
      [ariaLabel]="removeLabel()"
      (click)="removeRow(i)" />
  </div>
}

<div>
  <vx-button
    variant="outline"
    tone="secondary"
    size="sm"
    [disabled]="isDisabled()"
    (click)="addRow()">
    <vx-icon name="plus" size="sm" />
    {{ addLabel() }}
  </vx-button>
</div>
